import {observer} from "mobx-react-lite";
import {useRouterStore} from "mobx-state-router";
import {FormattedMessage, useIntl} from "react-intl";
import React, {useContext} from "react";
import {StateContext} from "../../../../../App";
import {Button, Col, CustomInput, FormGroup, Label, Row} from "reactstrap";
import {types} from "mobx-state-tree";
import Notification from "../../../../../utils/Notification";


export const IncludeModalState = types.model("IncludeModalState", {
  excludedFlag: types.optional(types.boolean, true),
  zeroScanCountFlag: types.optional(types.boolean, true),
}).actions(self => ({
  updateExcludedFlag(val) {
    self.excludedFlag = val;
  },
  updateZeroScanCountFlag(val) {
    self.zeroScanCountFlag = val;
  }
})).views(self => ({
  enabled() {
    return !self.excludedFlag || !self.zeroScanCountFlag;
  }
}))

export const IncludeModal = observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const intl = useIntl();
  const stateContext = useContext(StateContext);

  // const createStatusCheckBox = () => {
  //   return (
  //     <>
  //       {currentState?.defaultExcludedStatus.map((value) => (
  //         <Row key={value}>
  //           <Col>
  //             <FormGroup check inline>
  //               <CustomInput
  //                 type="checkbox"
  //                 id={`data-export-status-${value}`}
  //                 defaultChecked={true}
  //                 disabled={true}
  //               />
  //               <Label check>
  //                 {value}
  //               </Label>
  //             </FormGroup>
  //           </Col>
  //         </Row>
  //       ))}
  //     </>
  //   );
  // };

  return (
    <>
      <Row className="p-1">
        <Col className="d-flex justify-content-center">
          <div className="text-left">
            <CustomInput
              type="switch"
              id="data-export-settings-status-toggle"
              name="data-export-settings-status-toggle"
              checked={store?.excludedFlag}
              label="Exclude 'DELETED' codes by Default"
              onChange={() => {
                const statusColumn = currentState?.getStatusColumn();
                const filterOnStatusFound = currentState?.getFormData()?.filter?.definition?.onColumns?.filter(f => f.name === statusColumn.value)?.length > 0;
                if (!filterOnStatusFound) {
                  store?.updateExcludedFlag(!store?.excludedFlag);
                } else {
                  new Notification()
                    .setType("warning")
                    .setTitle("Status Filter Found")
                    .setMessage(`Remove the 'Status' filter before enabling the export settings.`)
                    .send();
                }
              }}
            />
            {currentState?.dataExportTypeSelected?.type === "scanCount" && (
              <CustomInput
                disabled
                type="switch"
                id="data-export-settings-scanCount-toggle"
                name="data-export-settings-scanCount-toggle"
                checked={store?.zeroScanCountFlag}
                label="Include codes with ZERO Scans"
                onChange={() => {
                  store?.updateZeroScanCountFlag(!store?.zeroScanCountFlag);
                }}
              />
            )}
          </div>
        </Col>
      </Row>
      {/*{store?.excludedFlag && (*/}
      {/*  <>*/}
      {/*    <Row className="p-1">*/}
      {/*      <Col>*/}
      {/*        <i>By default, codes in the following statuses will not appear in this report:</i>*/}
      {/*      </Col>*/}
      {/*    </Row>*/}
      {/*    <Row className="p-1">*/}
      {/*      <Col>*/}
      {/*        {currentState?.defaultExcludedStatus?.length > 0 ?*/}
      {/*          createStatusCheckBox() :*/}
      {/*          <b><i>None</i></b>*/}
      {/*        }*/}
      {/*      </Col>*/}
      {/*    </Row>*/}
      {/*  </>*/}
      {/*)}*/}

      <Row className="p-1">
        <Col>
          <FormGroup row>
            <Col sm={2}>
              <Button
                className="btn-outline-secondary mr-1"
                color="secondary"
                id="cancel-btn"
                onClick={() => {
                  currentState.modalStore.toggle();
                  store.updateExcludedFlag(currentState?.isCodeStatusExcludedByDefault);
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/>
              </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button
                outline
                color="primary"
                onClick={() => {
                  currentState?.updateIsCodeStatusExcludedByDefault(store?.excludedFlag);
                  currentState.modalStore.toggle()
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/>
              </Button>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
});
